<script>
    export let perPage = 25
    export let disabled
    export let totalCount
</script>

{#if totalCount > perPage}
    <div class="rows-per-page">Rows per page:
        <select class="form-select per-page" bind:value={perPage} disabled={disabled}>
            {#if perPage === 15}
                <option value={15}>15</option>
            {/if}
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
        </select>
    </div>
{/if}

<style>
    .rows-per-page {
        display: flex;
        align-items: center;
        white-space: nowrap;
        margin: 15px 0;
    }

    .rows-per-page select {
        margin-left: 10px;
        min-width: initial;
        width: initial;
    }

    @media(max-width: 767px) {
        .rows-per-page select {
            min-width: initial !important;
        }
    }
</style>
